export class MaandJaar {

  constructor(public maand: number,
              public jaar: number) {
  }
}
